import React, { useEffect } from "react";
import "./RecoveryRehab.css";
import AOS from "aos";
import "aos/dist/aos.css";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import rehabImg from "../../Asset/Images/RecoveryRehab.png";

const RecoveryRehab = () => {
  const { t } = useTranslation();

  useEffect(() => {
    AOS.init({
      duration: 1200,
      once: true,
    });
  }, []);

  // Keys for the 8 recovery and rehab support points
  const rehabPoints = [
    "rehab.point1",
    "rehab.point2",
    "rehab.point3",
    "rehab.point4",
    "rehab.point5",
    "rehab.point6",
    "rehab.point7",
    "rehab.point8"
  ];

  return (
    <div className="rr_page">
      {/* HERO SECTION */}
      <section className="rr_hero">
        <div className="rr_card_container">
          <div className="rr_content" data-aos="fade-right">
            <span className="rr_service_tag">{t('rehab.service_tag')}</span>
            <h1>
              {t('rehab.title_start')} <span>{t('rehab.title_end')}</span>
            </h1>
            <p>{t('rehab.hero_desc')}</p>
          </div>

          <div className="rr_image" data-aos="fade-left">
            <img src={rehabImg} alt={t('rehab.title_start') + " " + t('rehab.title_end')} />
          </div>
        </div>
      </section>

      {/* DETAILS SECTION */}
      <section className="rr_details">
        <h2 data-aos="fade-up">{t('rehab.details_title')}</h2>
        <div className="rr_grid">
          {rehabPoints.map((key, index) => (
            <div className="rr_card" key={index} data-aos="zoom-in">
              {t(key)}
            </div>
          ))}
        </div>
      </section>

      {/* CTA SECTION */}
      <section className="rr_cta" data-aos="fade-up">
        <h2>{t('rehab.cta_title')}</h2>
        <p>{t('rehab.cta_desc')}</p>
        <NavLink to="/Contactus">
          <button className="assisted_cta_btn">
            {t('common.contact_us')}
          </button>
        </NavLink>
      </section>
    </div>
  );
};

export default RecoveryRehab;